import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import P2 from '../typography/paragraphs/P2'
import Caption1 from '../typography/captions/Caption1'
import Caption4 from '../typography/captions/Caption4'
import FlexAlignCenter from '../presentational/FlexAlignCenter'
import {
  validateSecondsInput,
  preventUnwantedNumberKeys
} from '../../utils/resources'

const TextContainer = styled.div`
  margin-top: 15px;
  margin-bottom: 17px;

  > * {
    display: inline;
  }
`

const StartEndTimesContainer = styled(FlexAlignCenter)`
  margin-bottom: 26px;

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }
`

const StartEndTimeLabel = styled(P2)`
  margin-right: 13px;
`

const Colon = styled.div`
  height: 20px;
  color: #000000;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  margin: 0 5px;
`

const TimeInput = styled.input`
  height: 34px;
  width: 62px;
  border: 0.5px solid #bbbbbb;
  border-radius: 5px;
  background-color: #ffffff;
  text-align: center;
`

const YoutubeTrimmer = props => (
  <React.Fragment>
    <TextContainer>
      <Caption4>YouTube Links:&nbsp;</Caption4>
      <Caption1>
        Add a start and/or end time to limit play time within Quest! Web’s
        in-app video player.
        <br />
        Both fields are not required. The video will play from its original
        beginning or end if not specified.
      </Caption1>
    </TextContainer>

    <StartEndTimesContainer>
      <StartEndTimeLabel>Start Time</StartEndTimeLabel>
      <TimeInput
        type="number"
        min="0"
        onChange={event => props.setStartTimeMinutes(event.target.value)}
        placeholder="Min"
        defaultValue={props.startTimeMinutes}
        onKeyDown={e => preventUnwantedNumberKeys(e)}
      />
      <Colon>:</Colon>
      <TimeInput
        type="number"
        min="0"
        max="59"
        onChange={event => props.setStartTimeSeconds(event.target.value)}
        style={{ marginRight: '98px' }}
        onInput={e => validateSecondsInput(e)}
        placeholder="Sec"
        defaultValue={props.startTimeSeconds}
        onKeyDown={e => preventUnwantedNumberKeys(e)}
      />

      <StartEndTimeLabel>End Time</StartEndTimeLabel>
      <TimeInput
        type="number"
        min="0"
        onChange={event => props.setEndTimeMinutes(event.target.value)}
        placeholder="Min"
        defaultValue={props.endTimeMinutes}
        onKeyDown={e => preventUnwantedNumberKeys(e)}
      />
      <Colon>:</Colon>
      <TimeInput
        type="number"
        min="0"
        max="59"
        onChange={event => props.setEndTimeSeconds(event.target.value)}
        onInput={e => validateSecondsInput(e)}
        placeholder="Sec"
        defaultValue={props.endTimeSeconds}
        onKeyDown={e => preventUnwantedNumberKeys(e)}
      />
    </StartEndTimesContainer>
  </React.Fragment>
)

YoutubeTrimmer.propTypes = {
  startTimeMinutes: PropTypes.number,
  startTimeSeconds: PropTypes.number,
  endTimeMinutes: PropTypes.number,
  endTimeSeconds: PropTypes.number,
  setStartTimeMinutes: PropTypes.func.isRequired,
  setStartTimeSeconds: PropTypes.func.isRequired,
  setEndTimeMinutes: PropTypes.func.isRequired,
  setEndTimeSeconds: PropTypes.func.isRequired
}

export default YoutubeTrimmer



// WEBPACK FOOTER //
// ./src/components/activityedit/YoutubeTrimmer.js